export const COURIER_OPTIONS = [
  { value: 'SFEXPRESS', label: '顺丰速运' },
  { value: 'ZTO', label: '中通快递' },
  { value: 'JD', label: '京东物流' },
  { value: 'JITU', label: '极兔速递' },
  { value: 'YUNDA', label: '韵达快递' },
  { value: 'STO', label: '申通快递' },
  { value: 'YTO', label: '圆通快递' },
  { value: 'DEPPON', label: '德邦快递' }
];

const COURIER_LABELS = Object.fromEntries(COURIER_OPTIONS.map(c => [c.value, c.label]));

export function courierLabel(type) {
  return COURIER_LABELS[type] || type;
}
